export default async function listAnim({
  animateFunc,
  cardId,
  animation,
  transition,
}) {
  await animateFunc("[data-animate-id =" + cardId + "]", animation, transition);
}
